import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";
import PrivateMenuLeft from "../sections/Header/privateMenuLeft";
import PrivateMenuUp from "../sections/Header/privateMenuUp";
import BroadcastsModalCreate from "./modalCreate";
import Loader from "../../../components/Loader";
import useAuth from "../../../components/hooks/useAuth";



const HEADER_HEIGHT = 56;

const Broadcasts = () => {
  const [showCreate, setShowCreate] = useState(false);
  const [broadcastTitle, setBroadcastTitle] = useState("");
  const [broadcasts, setBroadcasts] = useState([]);
  const navigate = useNavigate();


  const [loadingList, setLoadingList] = useState(false);
  const { sidebarOpen, getApi, postApi, deleteApi } = useAuth();


  const loadList = async () => {


    setLoadingList(true);
    try {
      let response = await postApi("/api/v1/wpbroadcast/list", {
      });

      if (response) {
        setBroadcasts(response.lista);

      }

    } catch (error) {
      window.alert("Erro ao carregar:", error);
      // Aqui você pode tratar o erro (ex: toast de aviso)
    } finally {

      setLoadingList(false);
    }
  }
  useEffect(() => {
    loadList();
  }, []);


  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar Bootstrap 5 */}
      <PrivateMenuLeft />
      <PrivateMenuUp />



      {/* Conteúdo da página de campanha */}
      <div style={{
        marginLeft: window.innerWidth > 768 ? (sidebarOpen ? 220 : 70) : 0,
        paddingTop: HEADER_HEIGHT,
        width: window.innerWidth > 768
          ? sidebarOpen
            ? "calc(100% - 220px)"
            : "calc(100% - 70px)"
          : "100vw",
        transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
      }}>
        <div style={{ padding: 16, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h2 style={{ margin: 0, color: "#005c53", fontWeight: "bold" }}>Broadcasts</h2>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <button
              onClick={() => setShowCreate(true)}
              className="btn d-flex align-items-center"
              style={{ padding: '8px 14px', borderRadius: 8, boxShadow: 'none', fontWeight: 600, background: '#51a197', color: '#fff', border: 'none' }}
              title="Cadastrar"
            >
              <i className="bi bi-plus-lg" style={{ marginRight: 8, fontSize: 16, color: '#fff' }}></i>
              Cadastrar
            </button>
          </div>
        </div>
        {/* Conteúdo da página de campanha */}
        <style>{`
          .broadcasts-grid { display: flex; flex-wrap: wrap; gap: 16px; padding: 16px; }
          .broadcast-card { background: #fff; border-radius: 12px; padding: 16px; min-width: 320px; max-width: 420px; min-height: 110px; box-shadow: 0 6px 20px rgba(0,0,0,0.06); display:flex; align-items:flex-start; gap:16px; }
          .broadcast-icon { font-size: 28px; color: #005c53; position: relative; }
          .pulse-dot { width:12px; height:12px; border-radius:50%; background:#28a745; position:absolute; right:-6px; top:-6px; box-shadow: 0 0 0 rgba(40,167,69,0.7); animation: pulse 1.6s infinite; }
          @keyframes pulse { 0% { box-shadow: 0 0 0 0 rgba(40,167,69,0.7); } 70% { box-shadow: 0 0 0 10px rgba(40,167,69,0); } 100% { box-shadow: 0 0 0 0 rgba(40,167,69,0); } }
          .broadcast-title { font-weight:700; color:#222; word-break:break-word; font-size:16px; }
          .broadcast-meta { display:flex; flex-direction:column; gap:8px; margin-top:6px; }
          .broadcast-stats { display:flex; align-items:center; gap:12px; font-size:13px; color:#666; }
          .progress { width:160px; height:8px; background:#eef3f2; border-radius:999px; overflow:hidden; }
          .progress-fill { height:100%; background:linear-gradient(90deg,#51a197,#2f9e85); border-radius:999px; }
        `}</style>

        <div className="broadcasts-grid">
          {broadcasts.length === 0 && (
            <div style={{ color: '#666', padding: 16 }}>Nenhum broadcast criado ainda.</div>
          )}
          {loadingList && <Loader />}
          {broadcasts.map(b => (
            <div
              className="broadcast-card"
              key={b.id}
              role="button"
              tabIndex={0}
              onClick={() => navigate('/broadcast/' + b.id)}
              onKeyDown={(e) => { if (e.key === 'Enter') navigate('/broadcast/' + b.id); }}
              style={{ cursor: 'pointer' }}
            >
              <div style={{ position: 'relative', minWidth: 40 }}>
                <i className="bi bi-wifi broadcast-icon"></i>
                {b.alive && <span className="pulse-dot" />}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div className="broadcast-title">{b.name}</div>
                  <div style={{ fontSize: 12, color: '#888' }}>{b.alive ? 'Ativo' : 'Inativo'}</div>
                </div>
                <div className="broadcast-meta">
                  <div className="broadcast-stats">
                    <div style={{ fontWeight: 600, color: '#222' }}>{b.qtd_msg ?? 0}</div>
                    <div style={{ color: '#666' }}>mensagens enviadas</div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div className="progress"><div className="progress-fill" style={{ width: `${b.percentage ?? 0}%` }}></div></div>
                    <div style={{ fontSize: 12, color: '#666' }}>{b.percentage ?? 0}%</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {showCreate &&
          <BroadcastsModalCreate setShowCreate={setShowCreate} showCreate={showCreate} />}
      </div>
    </div>
  );
};

export default Broadcasts;